import { FC } from 'react';

import { Button, Col, FormFeedback, FormGroup, Label } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { BoximusPrime } from '@hsp/react-component-library';

import { s } from 'utilities/strings';

import { useMailCodeConfiguration } from './hooks';

const MailCode: FC = () => {
  const { errors, handleAssignMailCode, isAssignMailCodeEnabled, props, ref } = useMailCodeConfiguration();

  return (
    <FormGroup row>
      <Label sm={4}>{s('Site.MailCode')}</Label>
      <Col sm={8}>
        <div
          className={classNames('d-flex', {
            'is-invalid': get(errors, 'mailCode.type') === 'too_small',
          })}>
          <BoximusPrime
            {...props}
            className={classNames({
              'is-invalid': get(errors, 'mailCode.type') === 'too_small',
            })}
            placeholder={s(['Site.Enter', 'Site.MailCode'])}
            ref={ref}
            type="text"
          />
          <Button
            className="flex-shrink-0 ms-3"
            color="link"
            disabled={!isAssignMailCodeEnabled}
            onClick={handleAssignMailCode}
            type="button">
            {s(['Site.Assign', 'Site.MailCode'])}
          </Button>
        </div>
        <FormFeedback type="invalid">{get(errors, 'mailCode.message')}</FormFeedback>
      </Col>
    </FormGroup>
  );
};

export default MailCode;
